import { render } from "./KitsListView.vue?vue&type=template&id=37048694"
import script from "./KitsListView.vue?vue&type=script&lang=js"
export * from "./KitsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__